import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild , Renderer2, ElementRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { PrimeNGConfig } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-table-custom-filter',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    ReactiveFormsModule
  ],
  templateUrl: './table-custom-filter.component.html',
  styleUrl: './table-custom-filter.component.scss'
})
export class TableCustomFilterComponent {
  pageLinkSize: number = 5;
  compactPaginator = false;
  private bpSub?: Subscription;


  @Input() data: any[] = [];
  @Input() columns: any[] = [];
  @Input() rows: number = 5;
  @Input() rowsPerPageOptions: number[] = [5, 10, 25, 50];
  @Input() selection: any[] = [];
  @Input() sortField: string = '';
  @Input() sortOrder: number = -1;
  @Input() showFilters: boolean = true;
  @Input() deleteButton: boolean = false;
  @Input() DuplicateButton: boolean = false;
  @Input() optional: boolean = true;
  @Input() viewDetails: boolean = false;
  @Input() retryProcess: boolean = false
  @Input() customTemplates: { [field: string]: TemplateRef<any> } = {};
  @Input() showGlobalSearch: boolean = false;
  @Input() globalFilterFields: string[] = [];
  @Input() totalRecords: number = 0;
  @Input() first: number = 0;
  @Input() loading: boolean = false;
  @Input() enableFooterActions: boolean = false;
  @Input() enableTotalSelection: boolean = false;
  @Input() stickySearch: boolean = false;
  @Input() stickyPaginator: boolean = false;
  @Input() dataKey = 'id';
  @Input() itemEdit: boolean = false;


  @Output() selectionChange = new EventEmitter<any[]>();
  @Output() rowSelect = new EventEmitter<any>();
  @Output() deleteItems = new EventEmitter<any[]>();
  @Output() editItem = new EventEmitter<any>();
  @Output() exportItem = new EventEmitter<any>();
  @Output() cloneItem = new EventEmitter<any>();
  @Output() seeDetails = new EventEmitter<any>();
  @Output() retry = new EventEmitter<any>();
  @Output() lazyLoad = new EventEmitter<any>();
  @Output() acceptSelection = new EventEmitter<any[]>();
  @Output() cancelSelection = new EventEmitter<void>();
  
  constructor(
    private primengConfig: PrimeNGConfig,
    private bo: BreakpointObserver,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private breakpointObserver: BreakpointObserver
  ) {
    this.primengConfig.setTranslation({
      contains: 'Contiene',
      startsWith: 'Empieza con',
      notContains: 'No contiene',
      endsWith: 'Termina con',
      equals: 'Igual a',
      notEquals: 'No igual a',
      noFilter: 'Sin filtro',
      lt: 'Menor que',
      lte: 'Menor o igual que',
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      is: 'Es',
      isNot: 'No es',
      before: 'Antes',
      after: 'Después',
      dateIs: 'La fecha es',
      dateIsNot: 'La fecha no es',
      dateBefore: 'La fecha es antes',
      dateAfter: 'La fecha es después',
      clear: 'Limpiar',
      apply: 'Aplicar',
      matchAll: 'Coincidir con todo',
      matchAny: 'Coincidir con cualquiera',
      addRule: 'Agregar regla',
      removeRule: 'Eliminar regla',
      accept: 'Sí',
      reject: 'No',
      choose: 'Elegir',
      upload: 'Subir',
      cancel: 'Cancelar',
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      weekHeader: 'Sem',
      firstDayOfWeek: 1,
      dateFormat: 'dd/mm/yy',
      weak: 'Débil',
      medium: 'Medio',
      strong: 'Fuerte',
      passwordPrompt: 'Ingresa una contraseña',
      emptyMessage: 'No se encontraron resultados',
      emptyFilterMessage: 'No se encontraron resultados'
    });

  }

  @ViewChild('dt') dt!: any;
  
   ngOnInit(): void {
    this.bpSub = this.breakpointObserver
      .observe([Breakpoints.Handset, '(max-width: 600px)'])
      .subscribe(result => {
        if (result.matches) {
          // comportamiento para móvil
          this.pageLinkSize = 1;      // 1 numerito entre flechas
          this.compactPaginator = true;
        } else {
          // comportamiento para escritorio/tablet grande
          this.pageLinkSize = 5;
          this.compactPaginator = false;
        }
      });
  }

   ngOnDestroy(): void {
    this.bpSub?.unsubscribe();
  }

  getNestedValue(obj: any, path: string): any {
    //if (path !== 'roles')
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  onSeeDetails(event: any) {
    this.seeDetails.emit(event);
  }

  onRowSelect(event: any) {
    this.rowSelect.emit(event);
  }

  onSelectionChange(event: any) {
    this.selectionChange.emit(event);
  }

  onDeleteItems(items: any[]) {
    this.deleteItems.emit(items);
  }

  onEditItem(item: any) {
    this.editItem.emit(item);
  }

  onExport(item: any) {
    this.exportItem.emit(item)
  }

  onClone(item: any) {
    this.cloneItem.emit(item)
  }

  onRetry(item: any) {
    this.retry.emit(item)
  }

  filter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt.filterGlobal(value, 'contains');
  }

  loadData(event: any) {
    this.lazyLoad.emit(event);
  }

  onAcceptSelection() {
    this.acceptSelection.emit(this.selection);
  }

  onCancelSelection() {
    console.log('Cancelando selección en la tabla');
    this.selection = [];
    this.selectionChange.emit(this.selection);
    this.cancelSelection.emit();
  }

}
